// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"adjustRatingPopUp__gradient-bg5__bbAk9","adjustRatingPopUp":"adjustRatingPopUp__adjustRatingPopUp__Tf6eH"};